import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const updateSideNavSlice = createSlice({
  name: 'updateSideNav',
  initialState: {
    views: JSON.parse(localStorage.getItem('SavedCustomView')),
    customViewSelectedName: ""
  },
  reducers: {
    updateCustomViews: (state, action) => {
      state.views = action.payload;
      return state;
    },
    updateViewSelection: (state, action) => {
      state.customViewSelectedName = action.payload;
      return state;
    },
  }
})
// case under reducers becomes an action 
export const { updateCustomViews, updateViewSelection } = updateSideNavSlice.actions
export default updateSideNavSlice.reducer 
